import './eula.scss';

import * as gzEulaService from './eula.service';
import * as gzEulaCtrl from './eula.controller';

export default angular.module('gazelle.components.eula', [
  'ngMaterial',
  'rhino.components.locale',
  'rhino.core',
])
  .service(gzEulaService.name, gzEulaService.default)
  .controller(gzEulaCtrl.name, gzEulaCtrl.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/user/eula/eula.module.js